<template>
	    <div>
			<el-dialog title="自动规则管理" :append-to-body="append_body" :visible.sync="ruleDialogVisible" width="70%">
			   <el-row>
				   <el-col :span="24">
						<el-form :inline="true">				
							<el-form-item>
								 <el-button type="primary" @click="openCreateRule" size="small">+创建规则</el-button>
								 <el-dialog
								  title="自动规则创建/编辑"
								  :append-to-body="append_body"
								  :visible.sync="CreateRuledialogVisible"
								  width="50%">
								  <el-row>
								   <el-form :model="form" v-loading="editLoading">
										<el-form-item label="规则名称">
										  <el-input v-model="form.name" placeholder="请输入规则名称" style="width:60%"></el-input>
										</el-form-item>
										<el-form-item label="满足条件1">										  								  
										   <el-row :gutter="10">
											  <el-col :span="5">
											    <el-button size="small" style="width:100%" type="primary">消耗</el-button>
											  </el-col>
											  <el-col :span="5"><div class="grid-content bg-purple">
											    <el-button size="small" disabled style="width:100%" type="default">大于</el-button>
											  </div></el-col>
											  <el-col :span="10"><div class="grid-content bg-purple">											    
											    <el-input v-model="form.spend" size="small" style="width:60%;">
												 <template slot="append">元</template>
												</el-input>										
											  </div></el-col>
											</el-row>											
										</el-form-item>
										<el-form-item label="满足条件2">										  								  
										   <el-row :gutter="10">
											  <el-col :span="5">
											    <el-button size="small" style="width:100%" type="warning">CPI</el-button>
											  </el-col>
											  <el-col :span="5"><div class="grid-content bg-purple">
											    <el-button size="small" disabled style="width:100%" type="default">大于</el-button>
											  </div></el-col>
											  <el-col :span="10"><div class="grid-content bg-purple">										    
											    <el-input v-model="form.cpi" size="small" style="width:60%;">
												 <template slot="append">元</template>
												</el-input>										
											  </div></el-col>
											</el-row>											
										</el-form-item>
										<el-form-item label="执行动作">
										   <el-row :gutter="10">
											  <el-col :span="5">
											    <el-button size="small" disabled style="width:100%" type="default">创意状态</el-button>
											  </el-col>
											  <el-col :span="5"><div class="grid-content bg-purple">
											     
												  <el-button size="small" disabled style="width:100%" type="default">关闭</el-button>
											  </div></el-col>
											  <el-col :span="8"><div class="grid-content bg-purple">											    
											    
											  </div></el-col>
											</el-row>
										</el-form-item>
										<el-form-item label="发送通知">
										   <el-switch
													v-model="form.issend"
													active-color="#13ce66"
													active-value="0"
													inactive-value="1">
												  </el-switch>
										</el-form-item>
										
									</el-form>
								  </el-row>
								  <span slot="footer" class="dialog-footer">
								    <span style="float:left;color:#5f6769;font-size:12px;"><i style="font-size:7px;color:#f1bc31;" class="fa fa-circle"></i> 自动规则默认时间为每十分钟检测一次</span>
									<el-button @click="CreateRuledialogVisible = false">取 消</el-button>
									<el-button type="primary" @click="CreateRules">创 建</el-button>
								  </span>
								</el-dialog>
							</el-form-item>	
							<el-form-item>
								 <el-input size="small" style="width:150px;" v-model="keyword" placeholder="搜索名称/规则ID"></el-input>
							</el-form-item>
							<el-form-item>
								   <el-select v-model="advertiser_ids" size="small" placeholder="请选择">
										<el-option
										v-for="item in advertiserList"
										:key="item.value"
										:label="item.label"
										:value="item.value">
										</el-option>
									</el-select>
							</el-form-item>																
							<el-form-item>
								<el-button  size="small"><i  class="el-icon-search"></i> 查询</el-button>
							</el-form-item>				
						</el-form>															
					</el-col>
					<el-table :data="tableData" v-loading="listLoading" style="width: 100%">
					  <el-table-column prop="uuid" label="规则ID" width="250"></el-table-column>
					  <el-table-column prop="name" label="规则名称"></el-table-column>					 
					  <el-table-column prop="createtime" label="创建时间"></el-table-column>
					  <el-table-column prop="create_user" label="创建者"></el-table-column>
					  <el-table-column label="操作">
					   <template slot-scope="scope">
						<el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button>
						<el-button @click="removeRule(scope.row)" v-loading="removeLoading" type="text" size="small">删除</el-button>
					  </template>
					  </el-table-column>
					</el-table>
					<el-col :span="24">
					<div style="text-align:right;margin-top:10px;">
					  <el-pagination					 
					  :current-page="page"
					  :page-size="pagesize"
					  layout="total, prev, pager, next, jumper"
					  :total="total">
					</el-pagination>
					</div>
					</el-col>
			   </el-row>			
			</el-dialog>
			
		</div>
</template>
<script>
	import { addRules,getCreateRulesList,RemoveRule } from '../../../api/api';
	export default {		
		props:{
		  
		},		
		data() {
			return {
				sels:[],
				total:0,
				keyword:'',
				page:1,
				pagesize:12,
				form:{
				  action_field:'opt_status',
				  action_condition:'disable'
				  
				},
				tableData:[],
				listLoading:false,
				advertiser_ids:'',
				ruleDialogVisible:false,
				append_body:true,
				CreateRuledialogVisible:false,
				list:[],
				removeLoading:false,
				editLoading:false,
                advertiserList: []		
			}
		},
		computed:{
		   advertiser_id(){
		     return this.$store.getters.getAdvertiserId
		   },
		   userid(){
		    return this.$store.getters.getUserId
		   }
		},
		methods: {			
			openModel(){
			 this.ruleDialogVisible = true
			 this.getCreateRules()
			},
			openCreateRule(){
			 this.CreateRuledialogVisible = true
			 this.form ={}
			},
			removeRule(row){
			 this.$confirm('确认删除该规则吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.removeLoading = true;
					let para = { id: row.id };
					RemoveRule(para).then((res) => {
						this.removeLoading = false;
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getCreateRules();
					});
				}).catch(() => {

				});
			},
			handleClick(row){			
			 this.form ={}
			 this.form.id =row.id
			 this.form.name =row.name
			 this.form.issend = row.issend
			 let rule = JSON.parse(row.rules);			 
			 this.form.spend = rule.spend
			 this.form.cpi = rule.cpi
			 this.CreateRuledialogVisible = true
			},
           	CreateRules(){
			  if( !this.form.name )
			  {
			    this.$message.error('请填写规则名称');return false;
			  }
			  this.form.userid = this.userid
			  this.editLoading = true
			  addRules(this.form).then((res) => {
					this.editLoading = false
					this.CreateRuledialogVisible = false
					this.$message.success(res.message);
                    this.getCreateRules()					
			 });
			},
			getCreateRules(){
			  let params ={
			    page:this.page,
				pagesize:this.pagesize
			  }
			  this.listLoading = true
			  getCreateRulesList(params).then((res) => {
					this.listLoading = false
					this.tableData = res.data.list
                    this.total = res.data.total					
			 });
			},
			Confirm(){
			 this.$emit('func',this.sels)
			 this.ruleDialogVisible = false
			}
			
		},
		mounted() {
			
		}
	}

</script>
<style  lang="scss">
 
</style>


// WEBPACK FOOTER //
// automate_rules.vue?fb11f240